import { createFileRoute } from '@tanstack/react-router'
import { parseSearch } from '@/app/router/search-params'
import { SharedMapRoute } from '@/app/shell/map-route-shell'
import { publicMapExperience } from '@/experiences/public-map'

export const Route = createFileRoute('/event')({
  validateSearch: parseSearch,
  component: RouteComponent,
})

function RouteComponent() {
  const search = Route.useSearch()
  return (
    <SharedMapRoute
      routePath={Route.fullPath}
      search={search}
      experience={publicMapExperience}
      timeRangeNavigationEnabled={false}
      hideOfflineSensors
      hideRetiredSensors
      enableOnboardingTour
    />
  )
}
